import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ExtractionQuestion,
  QuestionType,
} from '../../../extraction-schema/domain/extraction-question.model';

@Component({
  selector: 'app-extraction-question-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './extraction-question-card.component.html',
  styleUrls: ['./extraction-question-card.component.scss'],
})
export class ExtractionQuestionCardComponent {
  @Input() question!: ExtractionQuestion;
  @Input() index!: number;
  @Input() isEditable: boolean = false;

  @Output() delete = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();

  getReadableType(type: QuestionType): string {
    switch (type) {
      case QuestionType.FULL_TEXT:
        return 'Text Field';
      case QuestionType.NUMERIC:
        return 'Numeric Value';
      case QuestionType.BOOLEAN:
        return 'Yes / No';
      case QuestionType.SINGLE_CHOICE:
        return 'Single Choice';
      case QuestionType.MULTI_CHOICE:
        return 'Multiple Choice';
      default:
        return 'Unknown';
    }
  }

  getTypeBadgeClass(type: QuestionType): string {
    switch (type) {
      case QuestionType.FULL_TEXT:
        return 'bg-blue-50 text-blue-700 border-blue-200';
      case QuestionType.NUMERIC:
        return 'bg-amber-50 text-amber-700 border-amber-200';
      case QuestionType.BOOLEAN:
        return 'bg-purple-50 text-purple-700 border-purple-200';
      case QuestionType.SINGLE_CHOICE:
        return 'bg-emerald-50 text-emerald-700 border-emerald-200';
      case QuestionType.MULTI_CHOICE:
        return 'bg-teal-50 text-teal-700 border-teal-200';
      default:
        return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  }

  onDelete(event: Event): void {
    event.stopPropagation();
    this.delete.emit();
  }
}
